import React, { HTMLAttributes } from 'react';
import InnerHTML from 'dangerously-set-html-content';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import type { ParagraphCustomHTML as Type } from '../../../types/paragraphs';

import './style.scss';

interface ParagraphCustomHTMLProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphCustomHTML: React.FC<ParagraphCustomHTMLProps> = ({
  id,
  entity,
}) => {
  const html = entity.getIn(['field_body', 0, 'value']);

  return (
    <div id={id} className="Paragraph ParagraphCustomHTML">
      <Container>
        <div className="row">
          <div className="ParagraphCustomHtml__inner col-12">
            <InnerHTML html={html} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphCustomHTML;
